import { TObject } from "../../../common/TObject";
import { Drawing } from "../Drawing";
import { GoogleFeature } from "./GoogleFeature";

import { Feature } from "./Feature";

export enum FeatureType {
    UNKNOWN = "Unknown",
    GOOGLE = "Google",
    LABEL = "Label"
}

export class Features extends TObject {

    Features: Feature[] = [];
    map: any; //Google
    readonly= false;

    editable(state: boolean) {
        this.Features.forEach(element => {
            element.editable(state);
        });
    }


    addGoogleFeature(feature: any, d: Drawing) {
        var s = new GoogleFeature(d, feature,this.readonly);
        this.add(s);

        s.fixStroke();
        return s;
    }

    add(f: Feature) {
        this.Features.push(f);
        return f;
    }

    findFeature(overlay) {
        var s = null
        this.Features.forEach(element => {
            if (element instanceof GoogleFeature) {
                if (element.overlay == overlay) {
                    s = element;
                }
            }
        });

        return s;
    }

    findFeatureById(id) {
        return this.Features.find(x => x.getId() === id);
    }

    deleteFeature(f: Feature) {
        if (f instanceof GoogleFeature) {
            if (f.overlay.feature) {
                this.map.data.remove(this.map.data.getFeatureById(f.overlay.feature.getId()));
            }
        }
        for (var o = 0; o < this.Features.length; o++)
            if (f == this.Features[o]) this.Features.splice(o, 1);

        f.delete();
        this.trigger('changed');
    }


    getFeatures(type: FeatureType) {
        return new Promise((resolve) => {
            var fs: Feature[] = [];
            for (var o = 0; o < this.Features.length; o++) {
                if (this.Features[o].type == type) {
                    fs.push(this.Features[o]);
                }
            }
            return resolve(fs);
        })
    }


}



